<template>
  <div class="max-w-4xl mx-auto bg-white text-gray-900 dark:bg-gray-900 dark:text-gray-100 min-h-screen p-4">
    <!-- Dark Mode Toggle -->
<div class="dark-mode-toggle mb-4 flex items-center space-x-2">
  <label for="darkToggle" class="switch">
    <input id="darkToggle" type="checkbox" :checked="darkMode" @change="toggleDarkMode" />
    <span class="slider round"></span>
  </label>
  <span>Dark Mode</span>
</div>


    <h2 class="text-3xl font-bold mb-6">Select a Subject</h2>

    <!-- Loading -->
    <div v-if="loading" class="text-center py-8">
      <div class="inline-block animate-spin rounded-full h-8 w-8 border-4 border-blue-500 border-t-transparent"></div>
      <p class="mt-2">Loading subjects...</p>
    </div>

    <!-- Error -->
    <div v-else-if="error" class="bg-red-100 dark:bg-red-950 border-l-4 border-red-500 text-red-700 dark:text-red-200 p-4 mb-6" role="alert">
      <p class="font-bold">Error</p>
      <p>{{ error }}</p>
    </div>

    <!-- Subjects Grid -->
    <div v-else>
      <div v-for="(yearData, year) in subjects" :key="year" class="mb-8">
        <h3 class="text-xl font-semibold mb-4 bg-gray-200 dark:bg-gray-800 p-2 rounded">{{ year }}</h3>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div
            v-for="(subjectData, subject) in yearData"
            :key="`${year}-${subject}`"
            class="bg-white dark:bg-gray-800 shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-shadow border dark:border-gray-700"
          >
            <div class="p-6">
              <h4 class="text-lg font-bold mb-2">{{ subject }}</h4>
              <p class="text-sm mb-4">
                {{ getTotalQuestions(subjectData) }} total questions across {{ subjectData.examSets?.length || 0 }} exam sets
              </p>

              <router-link
                :to="`/exam-select/${year}/${subject}`"
                class="inline-block bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded transition-colors"
              >
                Start Exam
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useDarkMode } from '../composables/useDarkMode'
import subjectsData from '../assets/subjects.json'

export default {
  name: 'HomeView',
  setup() {
    const subjects = ref({})
    const loading = ref(true)
    const error = ref(null)
    const { darkMode, toggleDarkMode } = useDarkMode()

    const getTotalQuestions = (subjectData) => {
      return subjectData.examSets?.reduce((sum, set) => sum + (set.questions?.length || 0), 0) || 0
    }

    onMounted(() => {
      try {
        subjects.value = subjectsData
        loading.value = false
      } catch (err) {
        error.value = 'Failed to load subjects.'
        loading.value = false
      }
    })

    return {
      subjects,
      loading,
      error,
      getTotalQuestions,
      darkMode,
      toggleDarkMode
    }
  }
}
</script>

<style>
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  cursor: pointer;
}

.slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}
input:checked + .slider {
  background-color: #2196F3;
}
input:checked + .slider:before {
  transform: translateX(26px);
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.dark-mode-toggle {
  display: flex;
  align-items: center;
}
.dark-mode-toggle span {
  margin-left: 0.5rem;
}
</style>
